import {
  EditorAutoSavePreferencesPanel,
  FileReviewPreferencesPanel,
  RecordDiscussionPreferencesPanel
} from '@jarvis/platform-ui';

export function SettingsEditorsPage() {
  return (
    <div className="user-settings-sections">
      <EditorAutoSavePreferencesPanel />
      <FileReviewPreferencesPanel />
      <RecordDiscussionPreferencesPanel />
    </div>
  );
}
